import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';

const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) return;

    const verify = async () => {
      try {
        const response = await fetch(`${apiBase}/api/auth/verify-email?token=${token}`);

        if (response.ok) {
          setSuccess(true);
        } else if (response.status === 400) {
          setError('This verification link has expired or has already been used');
        } else if (response.status === 500) {
          setError('Something went wrong on our end, please contact support');
        } else {
          setError('Something went wrong, please try again');
        }
      } catch {
        setError('Something went wrong, please try again');
      } finally {
        setIsLoading(false);
      }
    };

    verify();
  }, [token]);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => navigate('/login'), 2000);
      return () => clearTimeout(timer);
    }
  }, [success, navigate]);

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-header">
            <div className="login-brand">
              <h1>Invalid Link</h1>
              <p>This verification link is missing or malformed.</p>
            </div>
          </div>
          <div className="auth-modal-actions">
            <Link to="/login" className="auth-button text">Back to Login</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-brand">
            <h1>Email Verification</h1>
          </div>
        </div>

        <div className="login-form-container">
          <div className="auth-modal-content">
            {isLoading && (
              <p className="auth-modal-message" style={{ textAlign: 'center' }}>
                Verifying your email...
              </p>
            )}

            {success && (
              <p className="auth-modal-message" style={{ color: '#16a34a', fontWeight: 500, textAlign: 'center' }}>
                Email verified! Redirecting to login...
              </p>
            )}

            {error && (
              <>
                <div className="error-message" role="alert">
                  {error}
                </div>
                <div className="auth-modal-actions">
                  <Link to="/login" className="auth-button text">Back to Login</Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
